/* eslint-disable import/no-anonymous-default-export */
import { Button, Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import UsuariosContext from '../contexts/UsuariosContext';
//@ts-ignore
import wildcard from 'wildcard';
import PerfilAuth from "./PerfilAuth";
import BrandBar from "./BrandBar";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

export interface MenuItem {
    title: string,
    onClick?: () => any
    items?: MenuItem[],
    selectedPath?: string,
    key: string,
    permissions?: string[]
}

export interface NavMenuProps {
    items: MenuItem[]
    showBrandBar: boolean;
}

export default (props: NavMenuProps) => {
    const usuariosContext = useContext(UsuariosContext);
    const [usuarioRol, setUsuarioRol] = useState<any>();
    const location = useLocation();

    const hasPermission = (requiredPermissions: string[]) => {
        if (usuarioRol?.id == 1 || usuarioRol?.id == 3 || usuarioRol?.id == 6) {
            return true;
        }

        if (usuarioRol?.nombre === "Cobranzas" || usuarioRol?.nombre === "Juzgado") {
            return true;
        }

        for (const requiredPermission of requiredPermissions) {
            for (const permission of (usuarioRol?.permisos ?? [])) {
                if (wildcard(requiredPermission, permission.nombre)) {
                    return true;
                }
            }

        }
        return false;
    };


    const getSelectedItems = () => {

        const subitems = [];
        const items = props.items;


        for (const item of items) {
            if (item.items) {
                subitems.push(...item.items);
            }
        }

        return [...subitems, ...items].filter(item => item.selectedPath ? wildcard(item.selectedPath, location.pathname) : false).map(item => item);
    }

    useEffect(() => {
        setUsuarioRol(usuariosContext.user!.rol);
    }, []);


    return (
        <>
            {props.showBrandBar && <BrandBar />}
            <PerfilAuth />
            <Menu
                defaultSelectedKeys={getSelectedItems().map(i => i.key)}
                defaultOpenKeys={getSelectedItems().filter(i => i.items).map(i => i.key)}
                mode="inline"
                items={props.items
                    .filter(item => !item.permissions || hasPermission(item.permissions))
                    .map((item) => {
                        if (item.key === "neuralvision" && !process.env.REACT_APP_NEURALVISION_MODULE) {
                            return null;
                        }

                        if (item.items) {
                            // SubMenu con items
                            return {
                                key: item.key,
                                label: item.title,
                                children: item.items
                                    .filter(subItem => !subItem.permissions || hasPermission(subItem.permissions))
                                    .map((subItem) => ({
                                        key: subItem.key,
                                        label: subItem.title,
                                        onClick: subItem.onClick
                                    }))
                            };
                        } else {
                            // Menu Item simple
                            return {
                                key: item.key,
                                label: item.title,
                                onClick: item.onClick
                            };
                        }
                    })
                    .filter(item => item !== null) // Filtrar los null de neuralvision
                }
            >
                {/* {props.items
            .filter(item => !item.permissions || hasPermission(item.permissions))
            .map((item,index) => {
                if (item.key === "neuralvision" && !process.env.REACT_APP_NEURALVISION_MODULE) {
                return null;
                }
                if (item.items) {
                return (
                    <SubMenu title={item.title} key={item.key}>
                    {item.items
                        .filter(item => !item.permissions || hasPermission(item.permissions))
                        .map((subitem, subindex) =>
                        <Menu.Item key={subitem.key} onClick={subitem.onClick}>{subitem.title}</Menu.Item>
                        )}
                    </SubMenu>
                );
                } else {
                return (
                    <Menu.Item key={item.key} onClick={item.onClick}>{item.title}</Menu.Item>
                );
                }
            })} */}
            </Menu>
        </>
    );
};